import React from 'react';
import { Authenticated } from '@refinedev/core';
import { CatchAllNavigate, NavigateToResource } from '@refinedev/react-router';
import { Outlet } from 'react-router';
import { LoadingSpinner } from '@src/components/LoadingSpinner';
import { ROUTES } from './constants';

// Authenticated layout component for protected routes
export const AuthenticatedLayout = () => (
  <Authenticated
    key="authenticated-inner"
    fallback={<CatchAllNavigate to={ROUTES.LOGIN} />}
    redirectOnFail={ROUTES.LOGIN}
    loading={<LoadingSpinner size="small" tip="Loading..." />}
  >
    <Outlet />
  </Authenticated>
);

// Public layout component for auth pages
export const PublicLayout = () => (
  <Authenticated key="authenticated-outer" fallback={<Outlet />}>
    <NavigateToResource />
  </Authenticated>
);

// Route guard types for better type safety
export type RouteGuard = {
  canAccess: boolean;
  redirectTo?: string;
  message?: string;
};

// Custom route guard function (for future use)
export const checkRouteAccess = (
  route: string,
  userPermissions?: string[]
): RouteGuard => {
  // Add custom logic here for route-specific permissions
  const protectedRoutes = ['/dashboard', '/settings', '/users'];

  if (protectedRoutes.includes(route)) {
    return {
      canAccess: true, // This would be based on user permissions
      redirectTo: ROUTES.LOGIN,
      message: 'Access denied. Please log in.',
    };
  }

  return {
    canAccess: true,
  };
};
